import axios from 'axios';
import qs from 'query-string';

export const search = (url, params, key) => 
    axios.get(
        url + '?' + qs.stringify(params),
        {
            headers: {
                'X-api-key': key,
            }
        } 
    ).then(response => {
        return response.data;
    }).catch(err => {
        // eslint-disable-next-line
        console.error(err);
    })
